import CacheUtil from "../../../../../shared/lib/html5-software-library/src/ranj/util/CacheUtil";
import GameConfig from "../model/GameConfig";
import LocationView from "./LocationView";

export default class GameElementSkinFactory {

    /**
     * @param {GameConfig} gameConfig 
     * @param {Object} assets 
     */
    constructor(gameConfig, levelAssets) {
        this._gameConfig = gameConfig;
        this._assets = levelAssets;

        this._cachedViews = {};
    }

    getItem(index) {
        const skinName = this._gameConfig.getItemName(index);
        const skin = new this._assets[skinName]();
        const offset = this._gameConfig.getValue("itemOffsets")[index];
        skin.x = offset[0];
        skin.y = offset[1];
        return skin;
    }

    getLocation(index) {
        const skinName = this._gameConfig.getLocationSkin(index);
        return new this._assets[skinName]();
    }

    /**
     * @param {number} index 
     * @param {bool} cache 
     * @returns {LocationView}
     */
    getLocationView(index, cache = false) {
        const skinName = this._gameConfig.getLocationSkin(index);
        /**@type {LocationView} */
        let view;
        if (cache && this._cachedViews[skinName] != null) {
            view = this._cachedViews[skinName];
            view.reset();
        } else {
            const skin = new this._assets[skinName]();
            view = new LocationView(skin);
            if (cache) {
                this._cachedViews[skinName] = view;
            }
        }
        return view;
    }

    getLocationBounds(index) {
        const loc = this._gameConfig.getLocation(index);
        return new createjs.Rectangle(0, 0, loc.width, loc.height);
    }

}
